const initOurValues = (section) => {
	section.querySelectorAll('.our-values__toggle').forEach((button) => {
		button.addEventListener('click', () => {
			const item = button.closest('.our-values__item');
			const panel = item?.querySelector('.our-values__panel');
			const open = button.getAttribute('aria-expanded') === 'true';

			section.querySelectorAll('.our-values__item').forEach((other) => {
				const otherBtn = other.querySelector('.our-values__toggle');
				const otherPanel = other.querySelector('.our-values__panel');
				other.classList.remove('is-open');
				otherBtn?.setAttribute('aria-expanded', 'false');
				otherPanel?.setAttribute('aria-hidden', 'true');
			});

			if (!open && panel) {
				item.classList.add('is-open');
				button.setAttribute('aria-expanded', 'true');
				panel.setAttribute('aria-hidden', 'false');
			}
		});
	});
};

const boot = () => {
	document.querySelectorAll('.our-values').forEach((section) => {
		initOurValues(section);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
